module.exports = __webpack_public_path__ + "static/media/mujtaba.453050af.png";